import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';

const SummaryStep = ({ onClose, next, prev, children }) => {
  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button onClick={prev} sx={{ width: 150 }} variant="outlined">
        Back
      </Button>
      <Button onClick={next} sx={{ width: 150 }}>
        Submit
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={false}
      onHeaderButtonClick={onClose}
      title="Edit Load"
    >
      <ProgressBar label="Supplier (3 of 4)" value={75} />

      {children}
    </DrawerLayoutWrapper>
  );
};

SummaryStep.propTypes = {
  children: PropTypes.node.isRequired,
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default SummaryStep;
